export default {
  SITE_NAME: 'Texas Digital Identity Solution',
  SITE_NAME_ABBR: 'Texas Digital Identity Solution',
};
